import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import SecurityCard from './dchp/SecurityCard';
import ProfileCard from './dchp/ProfileCard';
import DependentCard from './dchp/DependentCard';
import PrivacyCard from './dchp/PrivacyCard';
import LanguageCard from './dchp/LanguageCard';
import { useDispatch, useSelector } from 'react-redux';
import InsuranceCard from './dchp/InsuranceCard';
import './dchp/settings.css';
import { Select } from '@material-ui/core';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import { updateDemographicsCleanUp } from '../../../redux/demographics/actions';
import { setSideNavItem } from '../../../redux/sidenavItems/actions';
import Label from '../../common/type/Label';
// import Label from '../../common/type/Label';

const Component = () => {
    const sideNavItem = useSelector(state => state?.sideNavItem?.activeNavItem);

    switch (sideNavItem) {
        case 'privacy': return <>
            <PrivacyCard />
        </>;
        case 'langpreference': return <>
            <LanguageCard />
        </>;
        case 'security': return <>
            <SecurityCard />
        </>;
        case 'dependents': return <>
            <DependentCard />
        </>;
        case 'thirdPartyInsurance': return <>
            <InsuranceCard />
        </>;
        default: return <>
            <ProfileCard />
        </>;
    }
};

const AccountSection = () => {
    const dispatch = useDispatch();
    const sideNavItem = useSelector(state => state?.sideNavItem?.activeNavItem);
   useEffect(() => {
       return () => {
        dispatch(setSideNavItem('accounts'));
        dispatch(updateDemographicsCleanUp());

       };
   }, []);
    const handleChange = (event) => {
        dispatch(setSideNavItem(event.target.value));
        dispatch(updateDemographicsCleanUp());
    };
    return <>
        <FormControl className='settingsFilter'>
            <InputLabel id="demo-simple-select-helper-label" style={{color: 'black'}}><Label id="selectASetting"/></InputLabel>
            <Select value={sideNavItem || ''} onChange={handleChange}
                renderValue={(value)=> (<span style={{color:'black'}}>{getLabel(value)}</span>)}
                labelId="demo-simple-select-helper-label"
                // label={'Select a settings'}
                displayEmpty
                variant='outlined'
                style={{ width: '98vw', margin: '10px 1vw' , color:'black'}}
            >
                <MenuItem value={'' || 'accounts'}>{getLabel('accounts')}</MenuItem>
                <MenuItem value='dependents'>{getLabel('dependents')}</MenuItem>
                <MenuItem value='langpreference'>{getLabel('langpreference')}</MenuItem>
                <MenuItem value='security'>{getLabel('security')}</MenuItem>
                <MenuItem value='thirdPartyInsurance'>{getLabel('thirdPartyInsurance')}</MenuItem>
                <MenuItem value='privacy'>{getLabel('privacy')}</MenuItem>
            </Select>
        </FormControl>
        <Component />
    </>;

};
const getLabel = (value)=> {
    switch (value) {
        
        case 'accounts': return <Label id='settingsAccountLabel'/>;
        case 'dependents': return <Label id='settingsDependentsLabel'/>;
        case 'langpreference': return <Label id='settingsSetLanguageLabel'/>;
        case 'security': return <Label id='settingsSecurityPreferenceLabel'/>;
        case 'thirdPartyInsurance': return <Label id='thirdPartyInsurance'/>;
        case 'privacy': return <Label id='settingsPrivacyPolicyLabel'/>;
        default: return <Label id='settingsAccountLabel'/>;
            
    }
};



AccountSection.propTypes = {
    navigate: PropTypes.func
};


export default AccountSection;
